<header id="navBar" class="login-header">
  <a class="login-header__brand" routerLink="/">
    <img src="assets/images/logo-airlines-blue.svg" class="navbar-svg-content" alt="Passe Livre LATAM">
  </a>
</header>

<!-- login main container -->
<main id="login-container">
  <!-- login centered card -->
  <section id="login-card" aria-labelledby="login-title">

    <img class="login-illustration" src="assets/images/login.png" alt="">

    <h1 id="login-title" class="welcome">Bem-vindo ao Passe Livre</h1>
    <p class="options_login">Selecione uma das opções a seguir para fazer login</p>

    <button type="button" class="btn-login btn-login_google" #loginGoogleBtn id="loginGoogleBtn">
      <img class="icon-google" src="assets/images/google-icon.png" alt="icone Google">
      Tripulantes LATAM
    </button>

    <button type="button" class="btn-login btn-external_login" (click)="toExternalLogin()">Tripulantes Externos</button>

    <p class="terms_text">
      Você está usando um aplicativo criado pela Latam Airlines.
      <button type="button" class="terms_link" (click)="openPrivacyPolicy()">Veja aqui nossa Política de Privacidade</button>
    </p>
  </section>
</main>
